import API from "./api";

// ✅ Get all product categories
export const getCategories = async () => {
    try {
        const response = await API.get("/products/categories");
        return response.data;
    } catch (error) {
        console.error("Error fetching categories:", error.response?.data || error.message);
        throw error;
    }
};

// ✅ Add a new category
export const addCategory = async (categoryData) => {
    try {
        const response = await API.post("/products/categories/add", categoryData, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error("Error adding category:", error.response?.data || error.message);
        throw error;
    }
};

// ✅ Update an existing category
export const updateCategory = async (categoryId, updatedData) => {
    try {
        const response = await API.put(`/categories/${categoryId}`, updatedData, {
            headers: { "Content-Type": "application/json" },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating category (${categoryId}):`, error);
        throw new Error(error.response?.data?.message || "Category update failed.");
    }
};

// ✅ Delete a category
export const deleteCategory = async (categoryId) => {
    try {
        const response = await API.delete(`/categories/${categoryId}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting category:", error);
        throw error;
    }
};
